module.exports = __webpack_public_path__ + "img/music-player-details1.421999ec.png";